import { FC } from 'react';
import { cn } from '@spikemark/ui/utils/cn';
import { PILL_COLORS, PILL_TEXT_COLORS } from './constants';
export interface PillProps {
  text: string;
  className?: string;
  color?: keyof typeof PILL_COLORS;
}
export const Pill: FC<PillProps> = ({
  text,
  className,
  color = 'default'
}) => {
  const colorClass = PILL_COLORS[color];
  const textColorClass = PILL_TEXT_COLORS[color];
  return <div className={cn('inline-flex items-center gap-1 rounded-full px-2 py-px text-[10px]', colorClass, textColorClass, className)} data-sentry-component="Pill" data-sentry-source-file="pill.tsx">
      {text}
    </div>;
};